const Ai = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4751 15.6001V11.8501M2.4751 4.3501V0.600098M0.600098 2.4751H4.3501M0.600098 13.7251H4.3501M8.8501 1.3501L7.54946 4.73174C7.33796 5.28167 7.2322 5.55663 7.06774 5.78791C6.92199 5.9929 6.7429 6.17199 6.53791 6.31775C6.30663 6.4822 6.03167 6.58796 5.48174 6.79946L2.1001 8.1001L5.48174 9.40073C6.03167 9.61224 6.30663 9.71799 6.53791 9.88245C6.7429 10.0282 6.92199 10.2073 7.06775 10.4123C7.2322 10.6436 7.33796 10.9185 7.54946 11.4685L8.8501 14.8501L10.1507 11.4685C10.3622 10.9185 10.468 10.6436 10.6325 10.4123C10.7782 10.2073 10.9573 10.0282 11.1623 9.88245C11.3936 9.71799 11.6685 9.61224 12.2185 9.40073L15.6001 8.1001L12.2185 6.79946C11.6685 6.58796 11.3936 6.4822 11.1623 6.31775C10.9573 6.17199 10.7782 5.9929 10.6324 5.78791C10.468 5.55663 10.3622 5.28167 10.1507 4.73174L8.8501 1.3501Z"
      stroke="#6D28D9"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Ai;
